export * from './objekt-arts-list.component';
export * from './objekt-arts-list.component.module';